import { DataGrid, GridColDef, GridValidRowModel } from "@mui/x-data-grid";
import { Empty } from "./Card";

export default function StatTable<R extends GridValidRowModel>({ rows, columns, getRowId, onRowClick }: {
  rows: R[]; columns: GridColDef<R>[]; getRowId: (row: R) => string; onRowClick?: (row: R) => void;
}) {
  if (rows.length === 0) return <Empty />;
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      getRowId={getRowId}
      density="compact"
      autoHeight
      disableRowSelectionOnClick
      hideFooter={rows.length <= 10}
      pageSizeOptions={[10, 25, 50]}
      initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
      onRowClick={onRowClick ? (params) => onRowClick(params.row as R) : undefined}
      sx={{ cursor: onRowClick ? "pointer" : undefined }}
    />
  );
}
